import {
  AlertTriangle,
  CheckCircle2,
  Clock,
  Loader2,
  PauseCircle,
  Route,
  Wrench,
} from 'lucide-react';
import {
  computeStatusCounts,
  FLEET_READINESS,
  KPI_ORDER,
  STATUS_CONFIG,
} from './mockAvailabilityData';

const KPI_ICONS = {
  check: CheckCircle2,
  loader: Loader2,
  route: Route,
  wrench: Wrench,
  alert: AlertTriangle,
  pause: PauseCircle,
  clock: Clock,
};

export default function StatusMatrixGrid({ fleet = FLEET_READINESS, activeFilter, onFilter }) {
  const counts = computeStatusCounts(fleet);

  return (
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7">
      {KPI_ORDER.map((statusKey) => {
        const config = STATUS_CONFIG[statusKey];
        const Icon = KPI_ICONS[config.kpiIcon];
        const count = counts[statusKey] || 0;
        const isActive = activeFilter === statusKey;

        return (
          <button
            key={statusKey}
            type="button"
            onClick={() => onFilter(isActive ? null : statusKey)}
            className={`relative overflow-hidden rounded-xl border bg-gradient-to-br p-3 text-left transition-all duration-200 ${config.kpiBg} ${
              isActive ? 'ring-2 ring-white/20 scale-[1.02]' : 'hover:brightness-110'
            }`}
          >
            <div className="flex items-start justify-between">
              <Icon className="h-4 w-4 opacity-80" strokeWidth={1.75} />
              <span className="font-mono text-2xl font-bold tabular-nums text-white">
                {count}
              </span>
            </div>
            <p className="mt-2 text-[10px] font-bold uppercase tracking-wide text-white/90">
              {config.kpiLabel}
            </p>
            <p className="mt-0.5 text-[9px] leading-tight text-logi-muted">{config.kpiHint}</p>
          </button>
        );
      })}
    </div>
  );
}
